import React from 'react'
import { connect } from 'react-redux'
import {
  Button,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from 'reactstrap'
import PropTypes from 'prop-types'

import { withTranslation } from 'react-i18next'

import AlertMessage from '../../components/AlertMessage'
import PageLoader from '../../components/PageLoader'
import localesActions from '../../localez/actions'

class LocaleDeleteConfirmModal extends React.Component {
  componentDidUpdate(prevProps) {
    const { onClose, removingStatus } = this.props
    const { removingStatus: prevRemovingStatus } = prevProps

    if (prevRemovingStatus === 'removing' && removingStatus === 'succeeded') {
      onClose()
    }
  }

  handleSubmit(event) {
    const { id, dispatch } = this.props

    event.preventDefault()

    dispatch(localesActions.remove(id))
  }

  render() {
    const {
      removingError,
      removingStatus,
      isOpen,
      onClose,
      t
    } = this.props

    return (
      <Modal isOpen={isOpen} toggle={() => onClose()}>
        <Form>
          <ModalHeader toggle={() => onClose()}>
            {t('LocaleDeleteConfirmModal.title')}
          </ModalHeader>
          <ModalBody>
            {t('LocaleDeleteConfirmModal.message')}

            {(removingStatus === 'removing') && (
              <PageLoader message={t('LocaleDeleteConfirmModal.removing')} />
            )}

            {removingStatus === 'failed' && (
              <AlertMessage>{removingError}</AlertMessage>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => onClose()}>
              {t('buttons.cancel', { ns: 'commons' })}
            </Button>
            <Button
              color="danger"
              onClick={(event) => this.handleSubmit(event)}
              type="submit"
            >
              {t('buttons.confirm', { ns: 'commons' })}
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    )
  }
}

LocaleDeleteConfirmModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  id: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  removingError: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  removingStatus: PropTypes.string,
  t: PropTypes.func.isRequired
}

LocaleDeleteConfirmModal.defaultProps = {
  id: null,
  removingError: null,
  removingStatus: 'idle'
}

const mapStateToProps = ({
  locales: {
    removingError,
    removingStatus
  }
}) => ({
  removingError,
  removingStatus
})

export default withTranslation(['LocalesPage', 'commons'])(
  connect(mapStateToProps)(LocaleDeleteConfirmModal)
)
